import React, { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import {
    letteringNeon,
    corporateBranding,
    vehicleWrapping,
    ledStorefront,
    exhibitionBooth,
    wayfindingSystem
} from '../assets/works';

const featuredProjects = [
    {
        id: 1,
        title: '3D LETTERING & NEON',
        category: 'Custom Fabrication',
        image: letteringNeon
    },
    {
        id: 2,
        title: 'CORPORATE BRANDING',
        category: 'Interior Signage',
        image: corporateBranding
    },
    {
        id: 3,
        title: 'VEHICLE WRAPPING',
        category: 'Mobile Advertising',
        image: vehicleWrapping
    },
    {
        id: 4,
        title: 'LED STOREFRONT',
        category: 'Retail Branding',
        image: ledStorefront
    },
    {
        id: 5,
        title: 'EXHIBITION BOOTH',
        category: 'Event Branding',
        image: exhibitionBooth
    },
    {
        id: 6,
        title: 'WAYFINDING SYSTEM',
        category: 'Directional Signage',
        image: wayfindingSystem
    }
];

function FeaturedProjects() {
    const sectionRef = useRef(null);
    const projectRefs = useRef([]);

    useEffect(() => {
        const observerOptions = {
            threshold: 0.1,
            rootMargin: '0px 0px -100px 0px'
        };

        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('visible');
                }
            });
        }, observerOptions);

        projectRefs.current.forEach(ref => {
            if (ref) observer.observe(ref);
        });

        return () => observer.disconnect();
    }, []);

    return (
        <section className="featured-projects-section" ref={sectionRef}>
            <div className="container-wide">
                <div className="section-header-new">
                    <h2 className="section-title-new">FEATURED PROJECTS</h2>
                    <Link to="/projects" className="load-more-link">
                        LOAD MORE <span>→</span>
                    </Link>
                </div>

                <div className="featured-grid">
                    {featuredProjects.map((project, index) => (
                        <div
                            key={project.id}
                            className="featured-project-card"
                            ref={el => projectRefs.current[index] = el}
                        >
                            <div className="featured-project-image">
                                <img src={project.image} alt={`${project.title} - ${project.category} by Rainbow Craft Signs & Graphics Dubai, UAE`} />
                                <div className="featured-project-overlay">
                                    <div className="featured-project-info">
                                        <h5 className="featured-project-category">{project.category}</h5>
                                        <h3 className="featured-project-title">{project.title}</h3>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}

export default FeaturedProjects;
